import React from 'react'
import {
  FilterBetweenDatesInner
} from '@Knowledge-OTP/znk-ui-components'
import useTranslation from '../../../i18n/useTranslation'

const StartDateFilter = (props) => {
  const { translate } = useTranslation()
  const { startDateFilter, setStartDateFilter, typeFilter } = props

  return (
      <FilterBetweenDatesInner
      className={'h45'}
        strings={{
          datesTitle: 'Start Date',
          buttonCancel: translate('filters.plans.buttonCancel'),
          buttonApply: translate('filters.plans.buttonApply'),
          from: 'Start date',
          to: 'End date'
        }}
        setDates={setStartDateFilter}
        typeFilter={typeFilter}
        dates={startDateFilter}
        direction={`bottomCenter`}
      />
  )
}
export default StartDateFilter
